import { UserProfilePopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/UserProfilePopout";

export { UserProfilePopout };
